import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import PrinterNumberField from '../../../inputs/PrinterNumberField';
import { PRINTER_NUMBER_MAX_LENGTH } from '../../../../constants';
import styles from './MobilePrinter.css';

interface ManualPrinterInputProps {
  printerNumber: string;
  onPrinterNumberChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  translationRoot: string;
  inputRootClass?: string;
  onSubmit?: () => void;
}

const ManualPrinterInput = forwardRef<HTMLInputElement, ManualPrinterInputProps>(({
  printerNumber,
  onPrinterNumberChange,
  translationRoot,
  inputRootClass,
  onSubmit,
}, ref) => {
  const { t } = useTranslation();

  return (
    <div className={styles.printerNumberInput}>
      <label htmlFor="printerNumber" className={styles.printerInputLabel}>
        {t(`${translationRoot}.MANUALLY_ADD_MOBILE_PRINTER`)}
      </label>
      <PrinterNumberField
        ref={ref}
        id="printerNumber"
        label={t(`${translationRoot}.PRINTER_PLACEHOLDER`)}
        value={printerNumber}
        onChange={onPrinterNumberChange}
        maxLength={PRINTER_NUMBER_MAX_LENGTH}
        inputRootClass={inputRootClass}
        onSubmit={onSubmit}
      />
    </div>
  );
});

ManualPrinterInput.displayName = 'ManualPrinterInput';

export default React.memo(ManualPrinterInput);
